<template>
	<div>
		<div class="Main">
			<div class="w">
				<div class="main">
					<div class="left">
						<!-- 返回列表开始 -->
						<div class="result_list">
							<!-- 标题 Start -->
							<div class="result_list_title">
								<h6 class="title_text" @click="prev">&lt; Return</h6>
								<!-- <div class="title_export">
                  <span class="export_text">显示物流轨迹</span>
                </div> -->
							</div>

							<!-- <div class="ccc" v-show="apple"> -->
							<div class="ccc">
								<div class="courierInfo">
									<!-- 顶部的地址和国内快递 -->
									<div class="courierInfo_top">
										<div class="top_left top_left_add">
											<span class="font">Mail number： </span>
											<span class="font" style="margin-right:12px"> {{waybillNoListId}}</span>
											<!-- <a href="javascript:volid(0)" @click="copy(waybillNoListId)" style="position: relative;">
												<svg t="1608629429313" @click="copy(waybillNoListId)" style="width:18px;height:18px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1971" width="200" height="200">
													<path d="M639.9 256.3H192.4c-35.2 0-63.9 28.8-63.9 63.9v575.4c0 35.2 28.8 63.9 63.9 63.9h447.5c35.2 0 63.9-28.8 63.9-63.9V320.2c0-35.1-28.8-63.9-63.9-63.9z m0 639.3H192.4V320.2h447.5v575.4z" p-id="1972" fill="#004b9c"></path>
													<path d="M831.6 64.5H384.1c-35.2 0-63.9 28.8-63.9 63.9v63.9h63.9v-63.9h447.5v575.4h-63.9v63.9h63.9c35.2 0 63.9-28.8 63.9-63.9V128.4c0.1-35.1-28.7-63.9-63.9-63.9z" p-id="1973" fill="#004b9c"></path>
												</svg>
											</a> -->
										</div>
									</div>
								</div>

							</div>

							<el-dialog :visible.sync="dialogVisible" :show-close=false :modal=false :modal-append-to-body=false alse width="100px">
								<div>
									<img src="../../../assets/img/query/queryCopyBlack.png" style="width: 120px;margin-left: -30px;margin-top: -70px;" />
									<p style="margin-top: -80px;"></p>
								</div>
							</el-dialog>
						</div>
						<!-- +++++++++++++++++++++++++++++++++++++++++++++ -->
            <!-- 修改部分 -->
            <div style="background: #FFFFFF;margin-top:5px;box-sizing: border-box;margin-bottom:100px">
							<div style="width: 1000px;height: auto;background: #FFFFFF;box-sizing: border-box;">
								<div class="trace" v-for="(data,index) in contentData" :key="index">
									<div class="dataNode">
                    <span>{{ data.opTime }}</span>
                  </div>
									<div class="lineBetween">
                    <div class="line" v-if="index!=0"></div>
                    <div class="circle" v-if="index==0||index == contentData.length - 1"></div>
                    <div v-else class="circle_gray"></div>
                  </div> 
									<div class="detailsDescribe">
                    <span>{{ data.enOpNameStr }}</span>
                    <span>{{ data.opDesc }}</span>
                  </div>
								</div>
							</div>
						</div>
					
          </div>
					<!-- 右二维码 -->
					<div class="right">
						<div class="content">
							<p class="title">扫码关注</p>
							<p class="tip">亲!想要实时关注此邮件状态？</p>
							<p class="tip">微信扫码关注，仅需一步！</p>

							<div class="item" style="padding: 21px 0px 6px 20px;">
								<img class="img" src="../../../assets/img/query/gongzhonghao.png" alt="" />
								<p class="text" style="padding: 0 0 0 10px;">中国邮政速递物流</p>
								<p class="text" style="padding:0 0 31px 30px;">微信服务号</p>
							</div>

							<div class="item" style="padding: 0px 0px 0px 20px;">
								<img class="img_two" src="../../../assets/img/query/er_phon.png" alt="" />
								<p class="text" style="padding-left: 40px;">手机app</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from "moment";
	import md5 from 'js-md5';
	let Base64 = require('js-base64').Base64
	export default {
		inject: ["reload"],
		name: "",
		data() {
			return {
				isFresh:"",//极速鲜
				mmtdFlag:"",//密码签收
				receiptFlag:"",//实物返单
				oneBillFlag:"",//一票多件
				postageTotal:"",//代收到付
				orderBy:false,//是干系人
				codFlag:"",//到付
				totalNum:"",
				codAmount:"",
				apple: true, //苹果件隐藏快递员信息
				overrun: "false",
				productName: "",
				logo:"",
				messagessData: '',
				messagessDataShow: false,
				typeNumber: 12345,
				timer:  null,
				closeShow: true,
				successData: "",
				resultStrData: "",
				  //定时器
				mainList: [],
				contentData: [],
				backColor: "",
				timeDifferenceData: [],
				current: 0,
				tencentMap: [],
				// info: data.info.mail.mailInfos,
				animate: true,
				notice: '',
				intervalId: null, // 定时器标识
				data: null,
				waybillNoListId: "", //物流单号id
				content: [],
				dialogTableVisible: false,
				// dialogTableVisible: true,
				dialogFormVisible1: false, //正确的
				dialogVisible: false,
				form: {
					name: "",
					region: "",
					date1: "",
					date2: "",
					delivery: false,
					type: [],
					resource: "",
					desc: "",
				},
				mailNo_list: {
					mailNo: [],
				},
				img: "",
				courier_textarea: "", //快递员的评论
				ems_textarea: "", //ems评论
				// 弹框评论的数据
				newLabelList: [],
				courierLabelConfigList: [], //评价快递员的可选框
				emsLabelConfigList: [], //评价ems的可选框
				delivererCity: "", //寄件地址
				receiverCity: "", //收件地址
				shouFlag: "", //运输中的箭头
				traceFlag: "",
				operatorPhone: "", //评价快递员手机号
				operatorName: "", //评价快递员姓名
				showName: "", // 展示快递员姓名
				showPhone: "", // 展示快递员手机号
				shouFlag: "", //当前快递的最新状态
				opName: "",
				// 判断快递员是否评价
				countryData: "",
				// 判断收寄件人手机号是下单人还是寄件人
				// 提交评论的数据
				checkList: [],
				courierCheckList: [],
				courType: "", //提交评论的类型
				// 运单详情按钮
				detailsOfWaybill: false,
				subscriptionBox: false, //订阅的框是否显示
				// 星星的数据
				heart_true: "",
				start_number: "5",
				comment_number: "5",
				grading: "",
				domorint_type: "", // 1国内 、 2国际
				problem_type: "",
				// 签收影像显示判断
				imgShow: true,
				// 收件人时候保价隐藏
				articlesValue: true,
				storageName: '',
				notes: '',
				forwardWaybillNo:'',//返单邮件号
				waybillNoShow:false,//没有登录不是干系人不展示
				detailOperatorName:"", //投递员姓名
				detailOpOrgName:"", //投递机构名称
				detailOpTime:"", //签收时间
				activeName:"first",//邮件详情页页面的切换
				getHeight:"",
				involved:"0",//干系人的状态   1、收件人   2、寄件人  6、下单人
			};
		},
		filters: {
			date: function(value) {
				return value.substring(0, 10);
			},
			time: function(value) {
				return value.substring(10, value.length);
			},
		},
		watch: {},
		mounted() {
			this.init();
		},
		destroyed() {
			clearInterval(this.intervalId) // 清除定时器
			
		},
		// 定义动画
		scroll() {
			this.animate = true
			const con1 = this.$refs.con1
			setTimeout(() => {
				con1.style.marginLeft = '-500PX'
			}, 500)
			setTimeout(() => {
				con1.style.marginLeft = '2500px'
				this.animate = false
			}, 15000)
		},
		methods: {
			/**
			 * 复制功能
			 * @param text
			 */
			copy: function(text) {
				const textarea = document.createElement("textarea"); //创建input对象
				const currentFocus = document.activeElement; //当前获得焦点的元素
				document.body.appendChild(textarea); //添加元素
				textarea.value = text;
				textarea.focus();
				if(textarea.setSelectionRange) {
					textarea.setSelectionRange(0, textarea.value.length); //获取光标起始位置到结束位置
				} else {
					textarea.select();
				}
				try {
					document.execCommand("copy"); //执行复制

					this.dialogVisible = true
					setTimeout(() => {
						this.dialogVisible = false
					}, 3000)

				} catch(error) {

				}
				document.body.removeChild(textarea); //删除元素
				currentFocus.focus();
			},

			/**
			 * 初始化地图 整理数据
			 */
			init() {
				// 查询信息接口
				this.query();
			},
			query() {
				let res = JSON.parse(localStorage.getItem("queryLog"));
				this.contentData = res.value.reverse();
        this.waybillNoListId = this.contentData[0].traceNo;
			},
			/**
			 * 返回按钮
			 */
			prev() {
				localStorage.removeItem("queryLog")
				// this.$router.go(-1);
				this.$router.push({
					path: '/'
				});
			},
		},
	};
</script>
<style>
	.blueBack {
		border: 1px solid #6d6d6d !important;
	}

	.blueMessage {
		margin-left: 20px;
		color: green;
		font-size: 14px;
		border: 1px solid green;
		line-height: 18px;
		border-radius: 16px;
		padding: 6px 14px;
		/* background: #008000; */
	}
</style>

<style scoped lang="scss">

	@import '../../../assets/css/english-css/query/queryLogistics.scss';
</style>